import { useContext, useEffect } from "react";
import { Link, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../routing/LangRouter";

//import redux store
import { saveTicketSelectedFilters } from "../../store/actions";

//import constants
import { IS_MOBILE } from "../../constants/breakpoints";

//import images and icons
import Icon from "../../components/common/base-icon/icon";

//import styles
import "./flight.scss";

function Flight({ dispatch }) {
    //general variables
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //sessionStorage variables
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};

    //handle links disable
    const handleDisable = event => {
        event.preventDefault();
    };

    //tab list
    const tabList = [
        {
            title: `${t("domesticFlight")}`,
            type: "domestic",
            status: "enable",
            activeLink: `/${locale}/flight-search/domestic` || `/${locale}/itinerary/flight-search/domestic`,
            activeIcon: "AirplanActiveIcon",
            inactiveIcon: "AirplanInactiveIcon",
        },
        {
            title: `${t("internationalFlight")}`,
            type: "international",
            status: `${isItinerary ? "disable" : "enable"}`,
            activeLink: `/${locale}/flight-search/international` || `/${locale}/itinerary/flight-search/international`,
            activeIcon: "IntlAirplanActiveIcon",
            inactiveIcon: "IntlAirplanInactiveIcon",
        },
    ];

    useEffect(() => {
        const action = searchParams.get("action");
        if (searchParams.size > 0) {
            if (action !== "search") searchParams.delete("action");
            searchParams.delete("hotelId");
            setSearchParams(searchParams);
        }
    }, []);

    useEffect(() => {
        const isFlightInternational = location.pathname.includes("/international");
        const updatedInfo = {
            isTicket: true,
            isAccommodation: false,
            isItinerary: false,
            isFlightInternational,
        };

        sessionStorage.setItem("generalInformation", JSON.stringify(updatedInfo));
    }, [location.pathname]);

    //handle filter cancellation
    const resetFilters = () => {
        dispatch(saveTicketSelectedFilters(null));
    };

    return (
        <Grid className="flight" container>
            <Grid
                className="flight__form"
                container
                item
                xs={12}
                rowGap={2.5}
                columnGap={1}
                justifyContent={{ xs: "space-between", md: "flex-start" }}
            >
                {tabList.map((tab, index) => {
                    return (
                        <Grid key={index} container item xs={5.8} md={2} alignItems="center">
                            <Link
                                className={`flight__tab ${tab.status} ${location.pathname === tab.activeLink ? "active" : ""}`}
                                to={tab.type}
                                onClick={tab.status === "disable" ? handleDisable : resetFilters}
                            >
                                <Icon
                                    name={location.pathname === tab.activeLink ? tab.activeIcon : tab.inactiveIcon}
                                    style={{ margin: "0 0.5rem" }}
                                />
                                {tab.title}
                            </Link>
                        </Grid>
                    );
                })}

                <Outlet />
            </Grid>
        </Grid>
    );
}

export default connect()(Flight);
